import { db } from '../../config/firebaseconfig'
import forOwn from 'mout/object/forOwn'
import mergeGroupUAScoring from './mergeGroupUAScoring';
import intersection from 'mout/array/intersection'
import convertAnswersByItem from './convertAnswersByItem';

export default function updateGroupUAs (
  student, subtestId, bySubtestScores, 
  byNodeScores, byItemScores, schoolYear, 
  assessmentId, byTestScores = {}, 
  assessmentSubtests, assessmentSet,
  destructuredSubtests, answersByItem
) {
  // get the classes, teachers, school, and district groupUAs
  // if any don't exist, they are the report
  // if they do exist, they are incremented by the values 
  let classIds = []
  forOwn(student.classes, (val, key) => {
    if (val) {
      classIds.push(key)
    }
  })

  // get classes, school, district
  let getClasses = []
  classIds.forEach((classId) => {
    getClasses.push(
      db.collection('classes').doc(classId).get()
    )
  })

  let classes = {}
  let teachers = {}
  let school = {}
  let district = {}
  return Promise.all(getClasses).then((results) => {
    results.forEach((result) => {
      const data = result.data()
      classes[data.id] = data
    })
    let teacherList = []
    forOwn(classes, (val) => {
      teacherList.push(val.teacher)
    })
    teacherList = intersection(teacherList)
    // now that I have all the teachers, classes, school, and district
    // I can update all of the groupUAs
    const teachersList = teacherList.map((id) => {
      return {
        groupType: 'Teacher', 
        id,
      }
    })
    const classList = classIds.map((id) => {
      return {
        groupType: 'Class',
        id,
      }
    })
    let idList = classList.concat(teachersList)
    idList.push({id: student.school, groupType: 'School'})
    idList.push({id: student.schoolDistrict, groupType: 'School District'})
    let promises = []
    idList.forEach((group) => {
      const groupUARef = db.collection('groupUA').doc(group.id)
      db.runTransaction((transaction) => {
        return transaction.get(groupUARef).then((doc) => {
          let newData = {
            state: student.state,
            school: student.school,
            district: student.schoolDistrict,
            groupType: group.groupType,
            id: group.id,
            [schoolYear]: {
              [assessmentId]: {
                assessmentId,
                assessmentSet,
                assessmentSubtests,
                year: schoolYear,
                groupType: group.groupType,
                groupId: group.id,
                destructuredSubtests,
                students: {
                  [student.id]: true
                },
                scoring: {
                  byNode: {
                    [subtestId]: {
                      ...byNodeScores,
                    }
                  },
                  bySubtest: {
                    [subtestId]: {
                      ...bySubtestScores,
                      studentCount: 1,
                      students: {
                        [student.id]: true,
                      }
                    }
                  },
                  byItem: {
                    [subtestId]: {
                      ...byItemScores,
                    }
                  },
                },
                upToDate: true,
                lastUpdated: Date.now(),
              }
            }
          }
          if (group.groupType === 'Teacher') {
            newData.teacher = group.id
          } else if (group.groupType === 'Class') {
            newData.teacher = classes[group.id].teacher
          }
          if (byTestScores.complete) {
            newData[schoolYear][assessmentId].scoring.byTest = {
              ...byTestScores,
              studentCount: 1,
              students: {
                [student.id]: true,
              }
            }
          }
          newData[schoolYear][assessmentId].answersByItem = {}
          newData[schoolYear][assessmentId].answersByItem[subtestId] = answersByItem ? convertAnswersByItem(answersByItem[subtestId]) : {}

          if (doc.exists) {
            const gUA = doc.data()
            if (!gUA[schoolYear]) {
              const updateKey = `${schoolYear}`
              transaction.update(groupUARef, {[updateKey]: newData[schoolYear]})
            } else if (!gUA[schoolYear][assessmentId]) {
              const updateKey = `${schoolYear}.${assessmentId}`
              const updateData = newData[schoolYear][assessmentId]
              transaction.update(groupUARef, {[updateKey]: updateData})
            } else {
              const newGUAData = mergeGroupUAScoring(gUA[schoolYear][assessmentId], newData[schoolYear][assessmentId], subtestId, student.id)
              const updateKey = `${schoolYear}.${assessmentId}`
              const updateData = newGUAData
              transaction.update(groupUARef, {[updateKey]: updateData})
            }
          } else {
            transaction.set(groupUARef, newData)
          }
        })
      })
    })
  })
}


// WEBPACK FOOTER //
// ./src/helpers/assessment/updateGroupUAs.js